import { Icon } from "@/ui-kit";
import {
  getItemsForOrg,
  reviewWidgets,
} from "components/ContentfulRenderer/ContentfulHero/ReviewsSection";
import { useAllValidAnimals } from "components/Signup/store/selectors/animals";
import useBreakPoints from "hooks/useMediaQuery";
import { createElement, useEffect, useMemo, useState } from "react";
import { Trans, useWebTranslation } from "translations";
import Colors from "ui-kit/colors";
import { Typography } from "ui-kit/Typography";
import { getOrg } from "utils/site";
import { SpeciesEnum } from "../../../../../__generated__/globalTypes";
import Cat from "../../../../assets/animations/cat.json";
import Dog from "../../../../assets/animations/dog.json";
import styles from "./LoadingScreen.module.css";
import { useLottieAnimation } from "hooks/useLottieAnimation";

const reviews = [
  "signup.loading.testimonial1",
  "signup.loading.testimonial2",
  "signup.loading.testimonial3",
];

export const LoadingScreen = () => {
  const { t } = useWebTranslation();

  const translatedReviews = useMemo(
    () =>
      reviews.filter((review) => {
        const translatedReview = t(review);

        return translatedReview !== "";
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps -- `t` isn't stable
    []
  );

  const [activeReviews, setActiveReviews] = useState<string[]>([]);
  const { isTablet } = useBreakPoints();
  const [firstAnimal, moreAnimals] = useAllValidAnimals();

  useEffect(() => {
    if (isTablet) {
      const randomIndex = Math.floor(Math.random() * translatedReviews.length);
      const randomReview = translatedReviews[randomIndex];

      setActiveReviews(randomReview ? [randomReview] : []);
    } else {
      setActiveReviews(translatedReviews);
    }
  }, [isTablet, translatedReviews]);

  const ref = useLottieAnimation({
    animation: firstAnimal.species === SpeciesEnum.dog ? Dog : Cat,
  });

  return (
    <>
      <div className={styles.top}>
        <div className={styles.content}>
          <Typography variant="body1" color="grey500">
            <strong>
              {moreAnimals
                ? t("signup.loading.title_multipet")
                : t("signup.loading.title", { name: firstAnimal.name ?? "" })}
            </strong>
          </Typography>
          <div
            ref={ref}
            className={styles.animation}
            style={{
              transform:
                firstAnimal.species === SpeciesEnum.dog
                  ? "translateY(47px)"
                  : "translateY(90px)",
            }}
          />
        </div>
      </div>
      <div className={styles.bottom}>
        <div className={styles.content}>
          <div className={styles.reviews}>
            {activeReviews.map((review) => {
              return (
                <div className={styles.review} key={review}>
                  <div className={styles.stars}>
                    <Icon name="star" size="L" color={Colors.sun400} />
                    <Icon name="star" size="L" color={Colors.sun400} />
                    <Icon name="star" size="L" color={Colors.sun400} />
                    <Icon name="star" size="L" color={Colors.sun400} />
                    <Icon name="star" size="L" color={Colors.sun400} />
                  </div>
                  <Typography variant="body1" color="blue300">
                    <strong>
                      <Trans
                        i18nKey={review}
                        components={[
                          <Typography
                            key={0}
                            variant="body3"
                            component="div"
                          />,
                        ]}
                      />
                    </strong>
                  </Typography>
                </div>
              );
            })}
          </div>
          <div className={styles.badges}>
            {getItemsForOrg(getOrg()).map((item, index) =>
              createElement(reviewWidgets[item], { key: item + index })
            )}
          </div>
        </div>
      </div>
    </>
  );
};
